import { GenericBackendResponse } from '../genericBackendResponse';
import { KycStatusResponse } from './interfaces/KycStatus';

const getKycStatus = async (token: string): Promise<GenericBackendResponse<KycStatusResponse>> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/kyc/status`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	if (!response.ok) {
		throw new Error(`KYC status request failed: ${response.status}`);
	}

	return response.json();
};

export default getKycStatus;
